var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 16,
    viewBox: "0 0 26 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6215 4.80696C13.1406 5.66141 13.0961 6.48916 13.8264 7.21011C14.5121 7.89545 15.3047 7.88654 16.124 7.46822C16.3555 8.61639 15.7766 9.76455 14.6902 10.3698C13.5948 10.9839 12.1521 10.7881 11.2349 9.90696C10.3444 9.05251 10.0861 7.54832 10.6382 6.40906C11.1904 5.27869 12.3659 4.62895 13.6215 4.79806V4.80696Z",
    fill: "#A3A5BA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9823 7.8511C25.9823 7.8511 25.9912 7.8422 26.0001 7.8333C25.8932 7.72649 25.7863 7.61969 25.6795 7.51288C23.462 5.05634 21.1645 2.91131 18.199 1.59403C15.5363 0.419163 12.7845 0.143247 9.9793 1.0333C6.37262 2.18147 3.74553 4.68251 1.09173 7.27257C0.931434 7.41497 0.771137 7.55738 0.61084 7.70869C0.61084 7.70869 0.619746 7.71759 0.628651 7.72649C0.628651 7.72649 0.619745 7.73539 0.61084 7.74429C0.717704 7.8511 0.82457 7.95791 0.931434 8.06471C3.14887 10.5213 5.44646 12.6663 8.41195 13.9836C11.0747 15.1584 13.8264 15.4343 16.6316 14.5443C20.2383 13.3961 22.8654 10.8951 25.5192 8.30503C25.6795 8.16262 25.8398 8.02021 26.0001 7.8689C26.0001 7.8689 25.9912 7.86 25.9823 7.8511ZM8.81269 10.1741C8.45648 9.4621 8.25165 8.66105 8.25165 7.8066C8.26056 4.97623 10.5582 2.65319 13.3277 2.6621C15.2602 2.6621 16.9433 3.77466 17.7982 5.38566C18.1544 6.0977 18.3593 6.89874 18.3593 7.75319C18.3504 10.5836 16.0528 12.9066 13.2832 12.8977C11.3507 12.8977 9.66761 11.7851 8.81269 10.1741Z",
    fill: "#A3A5BA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.4430963b683aa4068984a085a28005f8.svg";
export { ForwardRef as ReactComponent };